import React, { Component } from 'react';
import { connect } from "react-redux";
import '../../../../../Assets/EnsembleStyles/EnsFooter.css';
import Conversions from '../../../../../Resources/Conversions';
import {GetApplicationVersion} from '../../../../../action/Administration/administrationAction';
import { getCommonResources_Action } from '../../../../../action/cultureAction';


class EnsembleFooter extends Component {

    async componentWillMount() {
        const l_Request =  this.props.getCommonResources_Action();
        await Promise.all([l_Request]);
    }

    componentDidMount() {
        this.props.GetApplicationVersion();
         this.interval = setInterval(() => this.setState({ time: Conversions.getFooterTime() }), 1000);
      }

      componentWillUnmount() {
        clearInterval(this.interval);
      }

    constructor(props){
        super(props);
        this.state = {
              time: Conversions.getFooterTime()
             };
      }
    
    render(Version,Common_Resource_from_Store) {
        let VersionNo = "";
        let label = (this.props.Common_Resource_from_Store !== undefined && this.props.Common_Resource_from_Store !== null) ? this.props.Common_Resource_from_Store : [] ;

        if(this.props.Version !== undefined && this.props.Version !== null){
            VersionNo = this.props.Version;
            localStorage.setItem('Version', VersionNo);
        }
            
        return (
            <div>
                <div className="EnsFooter">
                    <div>
                        <p className="FooterLabel footer_year">{label["footer.copyright.Text"] !== undefined ? label["footer.copyright.Text"] : "© 2021 Trane"}  </p>
                        <p className="FooterLabel footer_version">{label["footer.lblversion.Text"] !== undefined ? label["footer.lblversion.Text"] : "Version"}  {VersionNo} </p>
                    </div> 
                    <div className="EnsFooterDatetime">
                        <p className="FooterLabel">    { this.state.time } </p>
                    </div>
                </div>
                <div className="Mob_EnsFooter">
                    <p className="FooterLabel footer_year"> ©&nbsp;2021&nbsp;Trane&nbsp;&nbsp;Tracer<sup>®</sup> &nbsp;Ensemble™ </p>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        Version: state.InstallationsRootReducer.ApplicationVersion,
        Common_Resource_from_Store: state.CommonResourceDataRootReducer.CommonResourcesData,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetApplicationVersion: () => dispatch(GetApplicationVersion()),
        getCommonResources_Action: () => dispatch(getCommonResources_Action()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EnsembleFooter);